// Mobile nav RFC.
$(document).on('click tap', '.mobile-nav-button', function (e) {
  e.stopPropagation();
  e.preventDefault();

  if ($('.lower-nav').height() > 0) {
    $('.lower-nav').css('height', 0);
    $('body').removeClass('lock-position');
  } else {
    $('body').addClass('lock-position');
    $('.lower-nav').css('height', $(window).height() - $('.mobile-header').height());
  }

  $('.navbar-toggle').click();

  return false;
});

// Mobile location finder close.
$(document).on('click tap', '.mobile-header .mobile-location-finder .close', function (e) {
  e.stopPropagation();
  e.preventDefault();

  $('.mobile-location-finder').hide();
  $('body').removeClass('not-small');
  if ($(window).scrollTop() > 0) {
    $('body').addClass('fixed-mobile');
  }

  return false;
});

// Mobile search.
$(document).on('click tap', '.mobile-header .mobile-search a', function (e) {
  e.stopPropagation();
  e.preventDefault();

  $('.mobile-location-finder').show();
  $('body').addClass('not-small');

  return false;
});
